import React, { useState } from "react";
import { Notification } from "../common/Notification";
import { useSelector, useDispatch } from "react-redux";
import { ApplicationState } from "../../store";
import * as service from "../../store/service";
import * as FamilyServiceActions from "../../store/familyService/actions";

const DeleteSeniorFamilyMemberDialog: React.FunctionComponent<{ closeDialog(): void; seniorMemberId: number }> = (props) => {
    const [isLoading, setisLoading] = useState(false);
    const dispatch = useDispatch();
    const getSeniorFamilyMember = () => dispatch(FamilyServiceActions.actionCreators.getSeniorFamilyMember());
    const seniorMemberList = useSelector((state: ApplicationState) =>
        state.familyServiceState && state.familyServiceState.seniorMemberList ? state.familyServiceState.seniorMemberList : []
    );
    const accountToRemove = seniorMemberList.find((x) => x.id === props.seniorMemberId);
    const firstName = accountToRemove && accountToRemove.firstName ? accountToRemove.firstName : "";
    const lastName = accountToRemove && accountToRemove.lastName ? accountToRemove.lastName : "";

    const closeDialog = () => {
        document.body.classList.remove("no_scroll");
        props.closeDialog();
    };

    const refreshFamilyMembersInformation = () => {
        getSeniorFamilyMember();
        closeDialog();
    };

    const removeAccount = () => {
        setisLoading(true);
        service
            .deleteSeniorFamilyMember(props.seniorMemberId)
            .then((data) => {
                if (data.hasError) {
                    Notification({
                        type: "error",
                        title: "Remove Senior Family Member Error",
                        message: "Could not remove senior family member. Please Try again later.",
                    });
                } else {
                    Notification({
                        type: "success",
                        title: "Remove Senior Family Member",
                        message: firstName + " " + lastName + " removed successfully.",
                    });
                }

                refreshFamilyMembersInformation();
                setisLoading(false);
            })
            .catch(() => {
                Notification({
                    type: "error",
                    title: "Error",
                    message: "We're sorry.We were unable to add your item.Please try again.",
                });
                refreshFamilyMembersInformation();
                setisLoading(false);
            });
    };

    return (
        <React.Fragment>
            {!isLoading ? (
                <>
                    <div className="dialog-header">
                        <div className="dialog-icon">
                            <em className="las la-minus-circle"></em>
                        </div>
                        <h1>Remove Senior Fraud Resolution?</h1>
                    </div>

                    <div className="dialog-body">
                        <p>
                            Are you sure you want to remove{" "}
                            <strong>
                                {firstName} {lastName}
                            </strong>
                            ?
                        </p>
                        <p>They will no longer be protected for Seniors Fraud Resolution services and/or expense reimbursement insurance.</p>
                    </div>

                    <div className="dialog-footer">
                        <div className="row between-xs">
                            <div className="col-xs col-no-gutter flex-grow-null">
                                <button type="button" className="btn-default btn-link btn-no-padding btn-no-border" onClick={() => closeDialog()}>
                                    <span className="btn-text">Cancel</span>
                                </button>
                            </div>
                            <div className="col-xs col-no-gutter flex-grow-null">
                                <button type="button" onClick={removeAccount} className="btn-default btn-primary">
                                    <span className="btn-text">Yes, Remove</span>
                                </button>
                            </div>
                        </div>
                    </div>
                </>
            ) : (
                <div className="box loading"></div>
            )}
        </React.Fragment>
    );
};

export default DeleteSeniorFamilyMemberDialog;
